// src/components/admin/MessageCenter.js
import React from 'react';
import MessageInbox from '../messages/MessageInbox';

const MessageCenter = () => <MessageInbox />;

export default MessageCenter;
